import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest({ timeout: 300000 });

export default {
  async importNestedLocations(params) {
    try {
      await checkLicenseExpiry();
          const data = await req.post('location/importNestedLocations', params);
    return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
};
